// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import type { ChartOptions, Plugin, TooltipItem, Chart } from 'chart.js/auto';
// import type { ChartOptions, Plugin, TooltipItem, ChartDataset, Chart, LegendItem } from 'chart.js/auto';

const CHART_FONT_FAMILY = 'DINPro, system-ui, -apple-system, blinkmacsystemfont, "Segoe UI", roboto, "Helvetica Neue", arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"';

// const CHART_OPTIONS_BAR_BASE = (showFilterTitle?: boolean): ChartOptions<'bar'> => {
const CHART_OPTIONS_BAR_BASE = (chartDataType?: string, decimalPlace?: number): ChartOptions<'bar'> => {
    return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'top',
                labels: {
                    filter: (item: { text: string }): boolean => {
                        return !!(item.text) && (item.text !== 'hidden');
                    },
                    font: { size: 16 },
                    color: '#5B6770',
                },
                title: {
                    display: false,
                    text: '  Filter:',
                    position: 'center',
                    color: '#373E43',
                    font: {
                        family: CHART_FONT_FAMILY,
                        size: 18,
                    },
                },
                align: 'center',
            },
            tooltip: {
                titleFont: { family: CHART_FONT_FAMILY },
                bodyFont: { family: CHART_FONT_FAMILY },
                callbacks: {
                    title: (tooltipItem: TooltipItem<'bar' | 'line'>[]): string => {
                        const item = tooltipItem?.[0];
                        if (item) {
                            const datasetType = item.dataset?.type;
                            if (datasetType === 'line') {
                                return '';
                            }

                            return item.label;
                        }

                        return '';
                    },
                    label: (tooltipItem: TooltipItem<'bar'>): string => {
                        // let decimalFraction = 0;
                        // if (chartDataType === 'participation'
                        //         || chartDataType === 'selfCollection'
                        //         || chartDataType === 'colonoscopy'
                        //         || chartDataType === 'colposcopy'
                        // ) {
                        //     decimalFraction = 2;
                        // }
                        const datasetLabel = tooltipItem.dataset.label;
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        const fixedValue = Number(tooltipItem.raw?.value || 0).toFixed(decimalPlace || 0);
                        const value = new Intl.NumberFormat('en-AU', { minimumFractionDigits: (decimalPlace || 0) }).format(Number(fixedValue));
                        if (datasetLabel && datasetLabel !== 'hidden') {
                            return `${datasetLabel}: ${value}`;
                        }
                        return ` ${value}`;
                    },
                },
            },
        },
        parsing: {
            xAxisKey: 'labelText',
            yAxisKey: 'value',
        },
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        maxBarThickness: 28,
        // borderRadius: 600,
    };
};

const CHART_OPTIONS_BAR_BASE_HORIZONTAL = (): ChartOptions<'bar'> => {
    return {
        indexAxis: 'y',
        parsing: {
            xAxisKey: 'value',
            yAxisKey: 'labelText',
        },
    };
};

const generateChartAxesLabel = (label?: string): unknown => {
    if (!label) {
        return undefined;
    }

    return {
        display: true,
        text: label,
        font: {
            size: 14,
            weight: 'bold',
        },
    };
};

const CHART_OPTIONS_BAR_VARIANT_1 = (max?: number, xAxisLabel?: string, yAxisLabel?: string): ChartOptions<'bar'> => {
    return {
        scales: {
            x: {
                stacked: true,
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                title: generateChartAxesLabel(xAxisLabel),
                // xAxisLabel ? { display: true, text: xAxisLabel, font: CHART_AXIS_LABEL_FONT } : undefined,
                // title: {
                //     display: true,
                //     text: 'xAxesTitle',
                // },
            },
            y: {
                suggestedMin: 0,
                suggestedMax: max ? max : undefined,
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                title: generateChartAxesLabel(yAxisLabel),
                //  yAxisLabel ? { display: true, text: yAxisLabel, font: CHART_AXIS_LABEL_FONT } : undefined,
                // title: {
                //     display: true,
                //     text: 'yAxesTitle',
                // },
            },
        },
        borderSkipped: false,
    };
};

const CHART_OPTIONS_BAR_VARIANT_1_HORIZONTAL = (max?: number, xAxisLabel?: string, yAxisLabel?: string): ChartOptions<'bar'> => {
    return {
        scales: {
            x: {
                suggestedMin: 0,
                suggestedMax: max ? max : undefined,
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                title: generateChartAxesLabel(xAxisLabel),
                // (xAxisLabel ? { display: true, text: xAxisLabel, font: CHART_AXIS_LABEL_FONT } as unknown : undefined),
                // title: {
                //     display: true,
                //     text: 'xAxesTitle',
                // },
            },
            y: {
                stacked: true,
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                title: generateChartAxesLabel(yAxisLabel),
                // (yAxisLabel ? { display: true, text: yAxisLabel, font: CHART_AXIS_LABEL_FONT } : undefined),
                // title: {
                //     display: true,
                //     text: 'yAxesTitle',
                // },
            },
        },
        borderSkipped: false,
    };
};

export const GetBarChartOptions = ({
    useHorizontalOptions,
    maxValue,
    chartDataType,
    xAxisLabel,
    yAxisLabel,
    decimalPlace = 0,
}: {
    useHorizontalOptions?: boolean;
    maxValue?: number;
    chartDataType?: string;
    xAxisLabel?: string;
    yAxisLabel?: string;
    decimalPlace?: number;
}): ChartOptions<'bar'> => {
    const baseOption = CHART_OPTIONS_BAR_BASE(chartDataType, decimalPlace);

    let variantOptions = {};
    let horizontalOption = {};

    if (useHorizontalOptions) {
        horizontalOption = CHART_OPTIONS_BAR_BASE_HORIZONTAL();
        variantOptions = CHART_OPTIONS_BAR_VARIANT_1_HORIZONTAL(maxValue, xAxisLabel, yAxisLabel);
    } else {
        variantOptions = CHART_OPTIONS_BAR_VARIANT_1(maxValue, xAxisLabel, yAxisLabel);
    }

    return {
        ...baseOption,
        ...horizontalOption,
        ...variantOptions,
    };
};

export const ChartPluginLegendMargin = (modifierValue: number): Plugin => {
    return {
        id: 'ChartPluginLegendMargin',
        beforeInit: (chart: Chart): void => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            const fitValue = chart.legend?.fit;

            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            chart.legend.fit = function fit(): number {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                fitValue.bind(chart.legend)();
                if (this) {
                    this.height += modifierValue;
                    return this.height;
                }

                return modifierValue;
                // return this.height += modifierValue; // eslint-disable-line no-return-assign
            };
        },
    };
};
